var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ProductsEditUser',{staticClass:"product-edit-left",attrs:{"product":_vm.product,"historyOfChanged":_vm.historyOfChanged},on:{"changeCategory":_vm.changeCategoryProform,"updateProduct":_vm.updateProduct}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }